module.exports = __webpack_public_path__ + "static/img/theme_2.3d9a3ee1.png";